import React from "react";
import {ImportSuccessIcon} from "../../utils/image";
import {Link} from "react-router-dom";
import {useSelector} from "react-redux";

const Done = () => {
    const {importResult} = useSelector(state => state.productReducer)

    return (
        <div className={"col space-y-8 py-6 border border-whisper-green rounded-lg"}>
            <div className={"col items-center justify-center space-y-4 border-b border-whisper-green py-10"}>
                <img src={ImportSuccessIcon} alt="ImportSuccess" className={"w-40"}/>
                <p className={"text-lg text-monstera"}>Import Complete</p>
                <p className={"text-forged-steel"}>Terdapat <span className={"font-bold"}>{importResult?.success}</span> Product diimpor dan <span className={"font-bold"}>{importResult?.skip}</span> Product di skip</p>
            </div>
            <div className={"row justify-center cursor-pointer"}>
                <Link to={'/product/product-list'} className={"font-Montserrat-Bold text-white bg-battleship-green hover:bg-monstera to-monstera px-16 py-4 rounded-lg"}>
                    <p>View Product List</p>
                </Link>
            </div>
        </div>
    )
}

export default Done
